import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';
import { handleResponse } from 'src/functions/http-handler';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private _apiUrl: string;

  constructor(
    @Inject(HttpClient) protected http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private logger: NGXLogger) {
    this._apiUrl = `${baseUrl}api/User`;
  }

  get(codes: Array<string>) {
    const param = { vendorCodes: codes };
    return this.http.get(this._apiUrl, { params: param })
      .pipe(handleResponse<Array<IUser>>(this.logger, 'retrieve user'));
  }

  searchByName(name: string) {
    const param = { name: name };
    return this.http.get(`${this._apiUrl}/Search`, { params: param })
      .pipe(handleResponse<Array<IUser>>(this.logger, 'search user'));
  }

  create(user: IUser) {
    return this.http.post(this._apiUrl, user)
      .pipe(handleResponse<IUser>(this.logger, 'create user'));
  }

  update(user: IUser) {
    return this.http.put(`${this._apiUrl}/${user.id}`, user)
      .pipe(handleResponse<IUser>(this.logger, 'update user'));
  }

  delete(user: IUser) {
    return this.http.delete(`${this._apiUrl}/${user.id}`)
      .pipe(handleResponse<IUser>(this.logger, 'delete user'));
  }

  searchById(id: string) {
    const param = { id: id };
    return this.http.get(`${this._apiUrl}/SearchId`, { params: param })
      .pipe(handleResponse<Array<IUser>>(this.logger, 'search userId'));
  }

}

export interface IUser {
  id: string,
  name: string,
  accountNum: string,
  orgName: string,
  department: string,
  email: string,
  admin_yn: string
}
